
import React from 'react';

const Card = ({ children, title, className = '' }) => {
  return (
    <div className={`bg-white rounded-lg shadow-md p-6 ${className}`}>
      {title && <h2 className="text-xl font-bold mb-4 text-gray-800 border-b pb-2">{title}</h2>}
      {children}
    </div>
  );
};

export default Card;
